/** @format */

import {Routes, Route, useLocation} from 'react-router-dom';

import {ROUTES} from 'constants/ROUTES';

import PrivateRoute from 'components/PrivateRoute';
import OwnerRoute from 'components/OwnerRoute';

import MainLayoutNew from 'layouts/MainLayoutNew';

import WizardModals from 'pages/Wizard/Modals';
import {Connect as WizardConnect} from 'pages/Wizard/Connect';

import ConfirmDeleteCompany from './ConfirmDeleteCompany';
import ConfirmPayAccounts from './ConfirmPayAccounts';
import Grouping from './Grouping';
import ConfirmPostpayBudget from './ConfirmPostpayBudget';
import ConfirmPrepayBudget from './ConfirmPrepayBudget';
import Connect from './Connect';
import Entry from './Entry';
import Manager from './Manager';
import PaymentMethods from './PaymentMethods';
import Profile from './Profile';
import Subscription from './Subscription';
import TwoFactorAuth from './TwoFactorAuth';
import WizardCompany from './Company';
import {Company} from './Connect/Company';
import {ConnectedUserList} from './ConnectedUsers/List';
import {EditUser} from './ConnectedUsers/components/EditUser';
import {NotificationFormNew} from './Notification/FormNew';
import {NotificationList} from './Notification/List';
import {SpecialistForm} from './Specialist/Form';
import {SpecialistList} from './Specialist/List';
import {Tariffs} from './Tariffs';

const Settings = () => {
  const location = useLocation();

  const background = location.state && location.state.background;

  return (
    <MainLayoutNew>
      <Routes location={background || location}>
        <Route
          index
          element={
            <PrivateRoute>
              <Entry />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS_PROFILE}
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS_GROUPING}
          element={
            <PrivateRoute>
              <Grouping />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS_TWO_FACTOR_AUTH}
          element={
            <PrivateRoute>
              <TwoFactorAuth />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS_CONNECTED_USERS}
          element={
            <PrivateRoute>
              <OwnerRoute>
                <ConnectedUserList />
              </OwnerRoute>
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.SETTINGS_CONNECT_COMPANY}/*`}
          element={
            <PrivateRoute>
              <Company />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS_NOTIFICATION}
          element={
            <PrivateRoute>
              <NotificationFormNew />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.SETTINGS_NOTIFICATIONS}/*`}
          element={
            <PrivateRoute>
              <NotificationList />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.SETTINGS_SPECIALISTS}/*`}
          element={
            <PrivateRoute>
              <SpecialistList />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS_MANAGER}
          element={
            <PrivateRoute>
              <Manager />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.SETTINGS_CONNECT}/*`}
          element={
            <PrivateRoute>
              <Connect />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS_SUBSCRIPTION}
          element={
            <PrivateRoute>
              <Subscription />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS_PAYMENT_METHODS}
          element={
            <PrivateRoute>
              <PaymentMethods />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.WIZARD}/*`}
          element={
            <PrivateRoute>
              <WizardCompany />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.WIZARD_COMPANY}
          element={
            <PrivateRoute>
              <WizardCompany />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.WIZARD_CONNECT}
          element={
            <PrivateRoute>
              <WizardConnect showInviteGuest />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.WIZARD_COMPANY_CONNECT}
          element={
            <PrivateRoute>
              <WizardConnect showInviteGuest />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS_TARIFFS}
          element={
            <PrivateRoute>
              <Tariffs />
            </PrivateRoute>
          }
        />
      </Routes>
      {background && (
        <Routes>
          <Route
            path={`${ROUTES.BEFORE_CONNECT}/*`}
            element={
              <PrivateRoute>
                <WizardModals.BeforeConnect />
              </PrivateRoute>
            }
          />
          <Route
            path={`${ROUTES.WIZARD_COMPANY_BEFORE_CONNECT}/*`}
            element={
              <PrivateRoute>
                <WizardModals.BeforeConnect />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.CONFIRM_DISCONNECT}
            element={
              <PrivateRoute>
                <WizardModals.ConfirmDisconnect />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.WIZARD_COMPANY_CONFIRM_DISCONNECT}
            element={
              <PrivateRoute>
                <WizardModals.ConfirmDisconnect />
              </PrivateRoute>
            }
          />
          <Route
            path={`${ROUTES.CONNECT_BEFORE_CONNECT}/*`}
            element={
              <PrivateRoute>
                <WizardModals.BeforeConnect />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.CONNECT_CONFIRM_DISCONNECT}
            element={
              <PrivateRoute>
                <WizardModals.ConfirmDisconnect />
              </PrivateRoute>
            }
          />

          <Route
            path={ROUTES.CONNECT_SUBACCOUNTS}
            element={
              <PrivateRoute>
                <WizardModals.Subaccounts />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.WIZARD_COMPANY_SUBACCOUNTS}
            element={
              <PrivateRoute>
                <WizardModals.Subaccounts />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.CONFIRM_DELETE_COMPANY}
            element={
              <PrivateRoute>
                <ConfirmDeleteCompany />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.CONFIRM_PAY_ACCOUNTS}
            element={
              <PrivateRoute>
                <ConfirmPayAccounts />
              </PrivateRoute>
            }
          />

          <Route
            path={ROUTES.SETTINGS_CONNECTED_USERS_ID}
            element={
              <PrivateRoute>
                <OwnerRoute>
                  <EditUser mode='edit' />
                </OwnerRoute>
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.SETTINGS_CONNECTED_USERS_NEW}
            element={
              <PrivateRoute>
                <OwnerRoute>
                  <EditUser mode='new' />
                </OwnerRoute>
              </PrivateRoute>
            }
          />
          <Route
            path={`${ROUTES.SETTINGS_SPECIALIST}/*`}
            element={
              <PrivateRoute>
                <SpecialistForm />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.CONFIRM_POSTPAY_BUDGET}
            element={
              <PrivateRoute>
                <ConfirmPostpayBudget />
              </PrivateRoute>
            }
          />

          <Route
            path={ROUTES.CONFIRM_PREPAY_BUDGET}
            element={
              <PrivateRoute>
                <ConfirmPrepayBudget />
              </PrivateRoute>
            }
          />
        </Routes>
      )}
    </MainLayoutNew>
  );
};

export default Settings;
